import { useQuery } from '@tanstack/react-query'
import { fetchMe } from '@/lib/api'
import { getUserOrMock } from '@/lib/tg'

export function AppHeader() {
  const user = getUserOrMock()
  const { data: me } = useQuery({ queryKey: ['me'], queryFn: fetchMe })
  const handle = '@' + (user.username ?? user.first_name.toLowerCase())
  const initial = (user.first_name || user.username || '?').trim().charAt(0).toUpperCase()
  const active = !!me?.is_active
  const until = me?.expires_at ? new Date(me.expires_at).toLocaleDateString('ru-RU') : '—'

  return (
    <header className="flex items-center gap-3 px-5 pt-3.5 pb-3">
      <div className="size-[38px] rounded-full shrink-0 flex items-center justify-center display text-[16px]"
        style={{ background: 'var(--color-surface-2)', border: '1px solid var(--color-line)', color: 'var(--color-accent)' }}>
        {initial}
      </div>
      <div className="min-w-0 flex-1">
        <div className="num text-[13.5px]" style={{ color: 'var(--color-ink)' }}>{handle}</div>
        <div className="num text-[10.5px] mt-0.5" style={{ color: 'var(--color-muted)' }}>
          {active ? `подписка до ${until}` : 'подписки нет'}
        </div>
      </div>
      <div className="text-right shrink-0">
        <div className="display text-[22px] leading-none" style={{ color: 'var(--color-ink)' }}>
          {active ? (me?.days_left ?? 0) : '—'}
        </div>
        <div className="num text-[9px] tracking-[0.16em] uppercase mt-1"
          style={{ color: 'var(--color-accent)' }}>{active ? 'дней' : 'нет доступа'}</div>
      </div>
    </header>
  )
}
